<template>
  <div class="body chat">
    <div class="yours messages">
      <div class="message last" v-html="message.replace(/\n/g, '<br/>')"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IPhoneMessage",
  props: {
    message: {
      type: String
    }
  }
};
</script>

<style scoped>
.body {
  font-family: helvetica;
  display: flex;
  flex-direction: column;
  /*align-items: center;*/
}

.chat {
  width: 350px;
  /*border: solid 1px #eee;*/
  display: flex;
  flex-direction: column;
  padding: 10px;
}

.messages {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
}

.message {
  border-radius: 20px;
  padding: 8px 15px;
  margin-top: 5px;
  margin-bottom: 5px;
  display: inline-block;
}

.yours {
  align-items: flex-start;
}

.yours .message {
  margin-right: 25%;
  background-color: #eee;
  position: relative;
}

.yours .message.last:before {
  content: "";
  position: absolute;
  z-index: 0;
  bottom: 0;
  left: -7px;
  height: 20px;
  width: 20px;
  background: #eee;
  border-bottom-right-radius: 15px;
}
.yours .message.last:after {
  content: "";
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: -10px;
  width: 10px;
  height: 20px;
  background: white;
  border-bottom-right-radius: 10px;
}
</style>
